import React from 'react';
import { useSelector } from 'react-redux';

import { ConsultantCianChat } from 'shared/containers/ConsultantCianChat';
import { isNewbuildingSelector } from 'shared/selectors/newbuilding';

/**
 *  Общий контейнер чатов
 * */
const ChatsContainer: React.FC = () => {
  const isNewbuildingsOnly = useSelector(isNewbuildingSelector);

  if (isNewbuildingsOnly) {
    return <ConsultantCianChat />;
  }

  return null;
};

// eslint-disable-next-line import/no-default-export
export default ChatsContainer;
